import { MutationTree } from 'vuex'
import { ImportState } from './types'
import { Range as AceRange } from 'brace'
import Metadata from '../wrappers/Metadata'
import Question from '../wrappers/Question'

export const mutations: MutationTree<ImportState> = {
  loadData (state, payload) {
    state.exam = payload.exam
  },

  loadQuestions (state, payload: {questionBody: string, metadatas: {explanation: string, skill_item_ids: number[]}[]}) {
    state.body = payload.questionBody
    const metadatas = payload.metadatas.map(function({explanation: explanation_val, skill_item_ids: skill_item_ids_val}) {
      return new Metadata(explanation_val, skill_item_ids_val)
    })
    let newQuestions: Question[] = []
    let index = -1
    state.body.split(/\n===+\n/).forEach((grouQuestionBody, groupIndex) => {
        newQuestions = newQuestions.concat(grouQuestionBody.split(/\n---+\n/).map((questionBody) => {index += 1; return new Question(metadatas[index], questionBody, groupIndex)}))
      })
    state.questions = newQuestions
  }
}
